import { render } from "./Avartar.vue?vue&type=template&id=70cd597e"
import script from "./Avartar.vue?vue&type=script&lang=js"
export * from "./Avartar.vue?vue&type=script&lang=js"

import "./Avartar.vue?vue&type=style&index=0&id=70cd597e&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__